const Invoices = () => {
  return (
    <div>
      <h3>Счет на оплату</h3>
      <p>Список выставленных счетов.</p>
    </div>
  );
};

export default Invoices;
